import React, { useState, useEffect } from 'react'
import {
    Grid, Box, TextField, Button, FormControlLabel, Checkbox, IconButton, useMediaQuery,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextareaAutosize,
    Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, List, ListItem, ListItemText
} from '@mui/material';
import ConsumptionRatio from '../../Dashboard/ConsumptionRatio';
import { useSelector, useDispatch } from "react-redux";
import { setState, updateWeeklyData } from '../reviewSlice';
import _ from "lodash";
import { CatchingPokemonSharp, TypeSpecimenRounded, Undo } from '@mui/icons-material';
import { createActionCreatorInvariantMiddleware } from '@reduxjs/toolkit';

const RowModification = (props) => {
    const dispatch = useDispatch();
    const review = useSelector((state) => state.review);
    const {
        ModifiedList,getWeekStatus
    } = review;
    const params = props.params;
    const type = props.type;
    const getUpdatedRowIds = props.getUpdatedRowIds;
    const selectedValues = props.selectedValues;
    const displayNewFinalQuota = selectedValues.includes("New Final Quota");
    const displayDeltaModifications = selectedValues.includes("Delta Modifications");
    const displayLastApprovedMod = selectedValues.includes("Last Approved Modification");
    const displayInitialQuota = selectedValues.includes("Initial Quota");
    const weeklyPullForward = props.weeklyPullForward;
    const rowSelectionModel = props.rowSelectionModel;
    const isCheckedHeader = props.isCheckedHeader;
    const modificationPercentage = props.modificationPercentage;
    const modPercFunc = props.modPercFunc;
    const rounderFunc = props.rounderFunc;
    const rounder = props.rounder;
    const updatedWeeklyData = props.updatedWeeklyData;
    const currentWeek = props.currentWeek;
    let weekNumber = parseInt(type.replace(/\D/g, ''), 10);
    const idx = updatedWeeklyData.findIndex((customer) => customer.customerQuotaID === params.row.customerQuotaID);
    const [newFinalQuota, setNewFinalQuota] = useState(updatedWeeklyData[idx].newFinalQuota[`${type}`]);
    const [deltaMod, setdeltaMod] = useState(updatedWeeklyData[idx].deltaModification[`${type}`]);

    const [disabled, setDisabled] = useState(false);
    const [values, setValues] = useState({
        weekly1: '',
        weekly2: '',
        weekly3: '',
        weekly4: '',
        weekly5: '',
    });

    const style = {
        p: 0,
        width: '100%',
        maxWidth: 400,
        fontSize: '10px',
        //borderRadius: 2,
        //border: '1px solid black',
        //borderColor: 'divider',
        textAlign: 'center'
        //backgroundColor: 'background.paper',
    };
    useEffect(()=>{
      if(newFinalQuota != updatedWeeklyData[idx].newFinalQuota[`${type}`] || deltaMod != updatedWeeklyData[idx].deltaModification[`${type}`]){
        setNewFinalQuota(updatedWeeklyData[idx].newFinalQuota[`${type}`]);
        setdeltaMod(updatedWeeklyData[idx].deltaModification[`${type}`]);
      }
    },[updatedWeeklyData[idx].newFinalQuota[`${type}`],updatedWeeklyData[idx].deltaModification[`${type}`]]);
    // useEffect(()=>{
    //     setNewFinalQuota(updatedWeeklyData[idx].newFinalQuota[`${type}`]);
    //     setdeltaMod(updatedWeeklyData[idx].deltaModification[`${type}`]);
    // },[]);
     // useEffect(() => {
    //     if(currentWeek === 1){
    //         setDisabled(true);
    //     }
    // },[currentWeek])

    // Function to validate the weekly values
    // const validateNewQuotaFields = (weeklyValues, rowId) => {
    //     let newErrors = { ...errors1 };
    //     let isValid = true;

    //     for (let i = 1; i <= 4; i++) {
    //         if (weeklyValues[`weekly${i}`] >= weeklyValues[`weekly${i + 1}`]) {
    //             isValid = false;
    //             newErrors[rowId] = { ...newErrors[rowId], [`weekly${i}`]: `Weekly${i} should be less than Weekly${i + 1}` };
    //         } else {
    //             // Clear the error if the validation is passed
    //             if (newErrors[rowId] && newErrors[rowId][`weekly${i}`]) {
    //                 delete newErrors[rowId][`weekly${i}`];
    //             }
    //         }
    //     }

    //     if (weeklyValues['weekly5'] >= weeklyValues['weekly4']) {
    //         isValid = false;
    //         newErrors[rowId] = { ...newErrors[rowId], ['weekly5']: 'Weekly5 should be less than Weekly4' };
    //     } else {
    //         // Clear the error if the validation is passed
    //         if (newErrors[rowId] && newErrors[rowId]['weekly5']) {
    //             delete newErrors[rowId]['weekly5'];
    //         }
    //     }

    //     setErrors1(newErrors);
    //     return isValid;
    // };
    // const isValidNewQuotaFields = validateNewQuotaFields(updatedWeeklyData);

    // const validateNewQuotaFields = (values) => {
    //     console.log(values);
    //     const errors1 = {};
    //     for (let i = 0; i < values.length - 1; i++) {
    //         if (values[i] >= values[i + 1]) {
    //             errors1[`weekly${i + 1}`] = `Weekly ${i + 1} should be less than Weekly ${i + 2}`;
    //         }
    //     }

    //     console.log(errors1);
    //     return errors1;
    // };
    const showMessage = (message, severity) => {
        dispatch(setState("message", message));
        dispatch(setState("severity", severity));
        dispatch(setState("messageOpen", true));
    };
    
    const handleValidity = (customerQuotaID) => {
      const Timer = setTimeout(() => {
        let isValid = true;
        if(isValid){
          let i = updatedWeeklyData.findIndex((customer) => customer.customerQuotaID === customerQuotaID);
            if (ModifiedList?.depletionModel?.toLowerCase() === "none") {
              if (
                updatedWeeklyData[i].newFinalQuota.weekly1 <
                updatedWeeklyData[i].consumption
              ) {
                showMessage(
                  "Quota value should not be less than Consumption value.",
                  "error"
                );
                isValid = false;
              }
            } else if (ModifiedList?.depletionModel?.toLowerCase() === "biweekly") {
              if (
                updatedWeeklyData[i].newFinalQuota.weekly1 >
                updatedWeeklyData[i].newFinalQuota.weekly2
              ) {
                showMessage(
                  "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
                  "error"
                );
                isValid = false;
              }
              if (
                updatedWeeklyData[i].newFinalQuota.weekly2 <
                  updatedWeeklyData[i].consumption ||
                (getWeekStatus.chkFirstHalf &&
                  updatedWeeklyData[i].newFinalQuota.weekly1 <
                    updatedWeeklyData[i].consumption)
              ) {
                showMessage(
                  "Quota value should not be less than Consumption value.",
                  "error"
                );
                isValid = false;
              }
            } else {
              if (
                getWeekStatus.chkWeek1 && (
                  updatedWeeklyData[i].newFinalQuota.weekly2 <
                    updatedWeeklyData[i].newFinalQuota.weekly1 ||
                  updatedWeeklyData[i].newFinalQuota.weekly3 < 
                    updatedWeeklyData[i].newFinalQuota.weekly2 || 
                  updatedWeeklyData[i].newFinalQuota.weekly4 < 
                    updatedWeeklyData[i].newFinalQuota.weekly3 || 
                  updatedWeeklyData[i].newFinalQuota.weekly5 < 
                    updatedWeeklyData[i].newFinalQuota.weekly4
                )
              ) {
                showMessage(
                  "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
                  "error"
                );
                isValid = false;
              }
              else if (
                getWeekStatus.chkWeek2 && (
                  updatedWeeklyData[i].newFinalQuota.weekly3 < 
                    updatedWeeklyData[i].newFinalQuota.weekly2 || 
                  updatedWeeklyData[i].newFinalQuota.weekly4 < 
                    updatedWeeklyData[i].newFinalQuota.weekly3 || 
                  updatedWeeklyData[i].newFinalQuota.weekly5 < 
                    updatedWeeklyData[i].newFinalQuota.weekly4
                )
              ) {
                showMessage(
                  "Quota value for weeks ahead of Week 2 should be greater than Week 2 value.",
                  "error"
                );
                isValid = false;
              }
              else if (
                getWeekStatus.chkWeek3 && (
                  updatedWeeklyData[i].newFinalQuota.weekly4 < 
                    updatedWeeklyData[i].newFinalQuota.weekly3 || 
                  updatedWeeklyData[i].newFinalQuota.weekly5 < 
                    updatedWeeklyData[i].newFinalQuota.weekly4
                )
              ) {
                showMessage(
                  "Quota value for weeks ahead of Week 3 should be greater than Week 3 value.",
                  "error"
                );
                isValid = false;
              }
              else if (
                getWeekStatus.chkWeek4 && (
                  updatedWeeklyData[i].newFinalQuota.weekly5 < 
                    updatedWeeklyData[i].newFinalQuota.weekly4
                )
              ) {
                showMessage(
                  "Week 5 Quota should be greater than previous Week Quota.",
                  "error"
                );
                isValid = false;
              }
              else if (
                updatedWeeklyData[i].newFinalQuota.weekly5 <
                  updatedWeeklyData[i].consumption ||
                (getWeekStatus.chkWeek4 &&
                  updatedWeeklyData[i].newFinalQuota.weekly4 <
                    updatedWeeklyData[i].consumption) ||
                (getWeekStatus.chkWeek3 &&
                  updatedWeeklyData[i].newFinalQuota.weekly3 <
                    updatedWeeklyData[i].consumption) ||
                (getWeekStatus.chkWeek2 &&
                  updatedWeeklyData[i].newFinalQuota.weekly2 <
                    updatedWeeklyData[i].consumption) ||
                (getWeekStatus.chkWeek1 &&
                  updatedWeeklyData[i].newFinalQuota.weekly1 <
                    updatedWeeklyData[i].consumption)
              ) {
                showMessage(
                  "Quota value should not be less than Consumption value.",
                  "error"
                );
                isValid = false;
              }
            }
        }
        return isValid;
      },500);
    };
    const handleNewQuotaChange = (e) => {
        let value = 0;
        if(e.target.value === ""){
            value = 0
        }
        else{
            value = Number(removeComma(e.target.value));
        }
        if (!isNaN(value)) {
        // The new value entered by the user
          setNewFinalQuota(value);
          
          //const updatedState = _.cloneDeep(updatedWeeklyData);
          //const customerToUpdate = updatedWeeklyData.find((customer) => customer.customerQuotaID === params.row.customerQuotaID);
          const deltaModificationVal = parseInt(value) - parseInt(params.row.lastApproved[`${e.target.name}`]);
          setdeltaMod(deltaModificationVal);
          //setUpdatedRow((prev) => ({ ...updatedRow, rowInfo2: { ...updatedRow.rowInfo2, [e.target.name]: deltaModificationVal } }))

          // const { name, value } = e.target;
          // const newValues = { ...values, [name]: Number(value) };
          //setValues(newValues);
          // setErrors1(validateNewQuotaFields(Object.values(newValues), params.id));

          //const newErrors = validateNewQuotaFields(Object.values(newValues));

          // Update the errors state only if there are changes
          // if (JSON.stringify(errors1) !== JSON.stringify(newErrors)) {
          //     setErrors1(newErrors);
          // }
          // const { name, value } = e.target;
  
          // validateNewQuotaFields(newWeeklyValues, params.id);
          // return { ...row, newFinalQuota: newWeeklyValues };


          const payload = {
              customerQuotaID: params.row.customerQuotaID, // Specify the customer ID
              key1: e.target.name, // Property to update (e.g., 'weekly1')
              value1: parseInt(value), // New value
              key2: e.target.name, // Property to update (e.g., 'weekly1')
              value2: deltaModificationVal // New value
          };
          dispatch(updateWeeklyData(payload));
          // if (customerToUpdate && _.has(customerToUpdate, payload.key1) && _.has(customerToUpdate, payload.key2)) {
          //     _.set(customerToUpdate, payload.key1, payload.value1);
          //     _.set(customerToUpdate, payload.key2, payload.value2);
          // }

          props.getUpdatedRowIds(params.row.customerQuotaID);
          if(e.target.name === 'weekly'+ currentWeek){
              dispatch(setState("isCurrentWeekRowChanged", true));
          }
        }else{
          showMessage("Only numbers are allowed in the New Final Quota field. Please enter a valid number", "error");
        }
        function removeComma(str) {
            let formattedString = "";
            for (let i = 0; i < str.length; i++) {
               if (str[i] !== ",") {
                  formattedString += str[i];
               }
            }
            return formattedString;
        }
    };

    const handleDeltaChange = (e) => {
        // The new value entered by the user
        let value = 0;
        if(e.target.value === "0-") {
          e.target.value = "-";
        }
        if(e.target.value === ""){
            value = 0
        }
        else{
            value = Number(removeComma(e.target.value));
        }
        if (!isNaN(value)) {
          setdeltaMod(value);
          const newQuotaVal = parseInt(value) + parseInt(params.row.lastApproved[`${e.target.name}`]);
          setNewFinalQuota(newQuotaVal);
          //setUpdatedRow((prev) => ({ ...updatedRow, rowInfo1: { ...updatedRow.rowInfo1, [e.target.name]: newQuotaVal } }))

          // const { name, value } = e.target;
          // const newValues = { ...values, [name]: Number(value) };
          //setValues(newValues);
          //setErrors2(validateDeltaModificationFields(Object.values(newValues)));
          // const newErrors = validateDeltaModificationFields(Object.values(newValues));

          // //const newErrors = validateNewQuotaFields(Object.values(newValues));

          // if (JSON.stringify(errors2) !== JSON.stringify(newErrors)) {
          //     setErrors2(newErrors);
          // }

          const payload = {
              customerQuotaID: params.row.customerQuotaID, // Specify the customer ID
              key1: e.target.name, // Property to update (e.g., 'weekly1')
              value1: newQuotaVal, // New value
              key2: e.target.name, // Property to update (e.g., 'weekly1')
              value2: parseInt(value), // New value
          };
          //const updatedState = _.cloneDeep(updatedWeeklyData); // Create a deep copy
          // Find the customer with the specified ID
          //const customerToUpdate = updatedState.find((customer) => customer.customerQuotaID === payload.customerQuotaID);

          // if (customerToUpdate && _.has(customerToUpdate, payload.key1) && _.has(customerToUpdate, payload.key2)) {
          //     _.set(customerToUpdate, payload.key1, payload.value1);
          //     _.set(customerToUpdate, payload.key2, payload.value2);
          // }
          dispatch(updateWeeklyData(payload));
          props.getUpdatedRowIds(params.row.customerQuotaID);
          if(e.target.name === 'weekly'+ currentWeek){
              dispatch(setState("isCurrentWeekRowChanged", true));
          }
        }else if (isNaN(value) && e.target.value.length === 1 && e.target.value === "-") {
          setdeltaMod(e.target.value);
          const newQuotaVal = parseInt(params.row.lastApproved[`${e.target.name}`]);
          setNewFinalQuota(newQuotaVal);
          const payload = {
              customerQuotaID: params.row.customerQuotaID, // Specify the customer ID
              key1: e.target.name, // Property to update (e.g., 'weekly1')
              value1: newQuotaVal,// New value
              key2: e.target.name, // Property to update (e.g., 'weekly1')
              value2: e.target.value, // New value
          };
          props.getUpdatedRowIds(params.row.customerQuotaID);
          if(e.target.name === 'weekly'+ currentWeek){
              dispatch(setState("isCurrentWeekRowChanged", true));
          }
        }else{
          showMessage(
            "Only numbers are allowed in the Delta Modification field. Please enter a valid number.",
            "error"
          );
        }
        function removeComma(str) {
            let formattedString = "";
            for (let i = 0; i < str.length; i++) {
               if (str[i] !== ",") {
                  formattedString += str[i];
               }
            }
            return formattedString;
        }
    };

    return (
        // <List sx={style}>
        //     <div> 
        //         {displayNewFinalQuota && 
        //         <ListItem>
        //             <TextField
        //                 size="small"
        //                 type="text"
        //                 name={`${type}`}
        //                 value={updatedRow?.newFinalQuota[`${type}`]}
        //                 onChange={handleNewQuotaChange}
        //             />
        //         </ListItem>}
        //         <Divider fullWidth component="li" />
        //         {displayDeltaModifications &&
        //         <ListItem>
        //             <TextField
        //                 size="small"
        //                 type="text"
        //                 name={`${type}`}
        //                 value={updatedRow?.deltaModification[`${type}`]}
        //                 onChange={handleDeltaChange}
        //             />
        //         </ListItem>}
        //         <Divider fullWidth component="li" />
        //         {displayLastApprovedMod && 
        //         <ListItem>
        //             <ListItemText primary={updatedRow?.lastApproved[`${type}`]} />
        //         </ListItem>}
        //         {displayInitialQuota &&
        //         <ListItem>
        //             <ListItemText primary={updatedRow?.initialQuota[`${type}`]} />
        //         </ListItem>}

        //     </div>

        // </List>

        <List sx={style}>
            {updatedWeeklyData?.map((row) => {
                return (params.row.customerQuotaID === row.customerQuotaID && <div>
                    {displayNewFinalQuota &&
                        <ListItem>
                            <TextField
                                size="small"
                                type="text"
                                sx={{ width: 105 }}
                                variant="standard"
                                inputProps={{ style: { fontSize: 12, textAlign: 'center' } }}
                                name={`${type}`}
                                disabled={(ModifiedList?.depletionModel?.toLowerCase() !== 'none' && weekNumber < currentWeek) ? true : false}
                                value={newFinalQuota?.toLocaleString()}
                                onChange={handleNewQuotaChange}
                                onBlur={() => {
                                    handleValidity(params.row.customerQuotaID);
                                }}
                                //error={!!errors1[`${type}`]}
                            //helperText={errors[`${type}`]}
                            // style={{
                            //     backgroundColor: !!errors1[`${type}`] ? '' : '#c8e6c9' // light green background for valid input
                            //   }}
                            />
                        </ListItem>}
                    <Divider fullWidth component="li" />
                    {displayDeltaModifications &&
                        <ListItem>
                            <TextField
                                size="small"
                                type="text"
                                sx={{ width: 105 }}
                                variant="standard"
                                inputProps={{ style: { fontSize: 13, textAlign: 'center' } }}
                                disabled={(ModifiedList?.depletionModel?.toLowerCase() !== 'none' && weekNumber < currentWeek) ? true : false}
                                name={`${type}`}
                                value={deltaMod?.toLocaleString()}
                                onChange={handleDeltaChange}
                                onBlur={() => {
                                    handleValidity(params.row.customerQuotaID);
                                }}
                                //error={!!errors2[`${type}`]}
                            //helperText={errors[`${type}`]}
                            // style={{
                            //     backgroundColor: !!errors2[`${type}`] ? '' : '#c8e6c9' // light green background for valid input
                            //   }}
                            />
                        </ListItem>}
                    <Divider fullWidth component="li" />
                    {displayLastApprovedMod &&
                        <ListItem>
                            <ListItemText
                                sx={{ textAlign: 'center', paddingRight: '10px' }}
                                primary={row?.lastApproved[`${type}`]?.toLocaleString()}
                                primaryTypographyProps={{ fontSize: 13 }}
                            />
                        </ListItem>}
                    {displayInitialQuota &&
                        <ListItem>
                            <ListItemText
                                sx={{ textAlign: 'center', paddingRight: '10px' }}
                                primary={row?.initialQuota[`${type}`]?.toLocaleString()}
                                primaryTypographyProps={{ fontSize: 13 }}
                            />
                        </ListItem>}

                </div>
                )
            })
            }

        </List>
    );
}

export default RowModification